"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneLocationsEnum = void 0;
exports.instanceOfZoneLocationsEnum = instanceOfZoneLocationsEnum;
exports.ZoneLocationsEnumFromJSON = ZoneLocationsEnumFromJSON;
exports.ZoneLocationsEnumFromJSONTyped = ZoneLocationsEnumFromJSONTyped;
exports.ZoneLocationsEnumToJSON = ZoneLocationsEnumToJSON;
exports.ZoneLocationsEnumToJSONTyped = ZoneLocationsEnumToJSONTyped;
/**
 * * `H` - Hand
 * * `B` - Battlefield
 * * `C` - Command Zone
 * * `E` - Exile
 * * `G` - Graveyard
 * * `L` - Library
 * @export
 * @enum {string}
 */
var ZoneLocationsEnum;
(function (ZoneLocationsEnum) {
    ZoneLocationsEnum["H"] = "H";
    ZoneLocationsEnum["B"] = "B";
    ZoneLocationsEnum["C"] = "C";
    ZoneLocationsEnum["E"] = "E";
    ZoneLocationsEnum["G"] = "G";
    ZoneLocationsEnum["L"] = "L";
})(ZoneLocationsEnum || (exports.ZoneLocationsEnum = ZoneLocationsEnum = {}));
function instanceOfZoneLocationsEnum(value) {
    for (const key in ZoneLocationsEnum) {
        if (Object.prototype.hasOwnProperty.call(ZoneLocationsEnum, key)) {
            if (ZoneLocationsEnum[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ZoneLocationsEnumFromJSON(json) {
    return ZoneLocationsEnumFromJSONTyped(json, false);
}
function ZoneLocationsEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ZoneLocationsEnumToJSON(value) {
    return value;
}
function ZoneLocationsEnumToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=zoneLocationsEnum.js.map